// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ErrorDetail } from './ErrorDetail';
import {
  ErrorDetailFromJSON,
  ErrorDetailFromJSONTyped,
  ErrorDetailToJSON,
  ErrorDetailToJSONTyped,
} from './ErrorDetail';

/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
  /**
   *
   * @type {Array<ErrorDetail>}
   * @memberof ErrorResponse
   */
  errors: Array<ErrorDetail>;
}

/**
 * Check if a given object implements the ErrorResponse interface.
 */
export function instanceOfErrorResponse(value: object): value is ErrorResponse {
  if (!('errors' in value) || value['errors'] === undefined) return false;
  return true;
}

export function ErrorResponseFromJSON(json: any): ErrorResponse {
  return ErrorResponseFromJSONTyped(json, false);
}

export function ErrorResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ErrorResponse {
  if (json == null) {
    return json;
  }
  return {
    errors: (json['errors'] as Array<any>).map(ErrorDetailFromJSON),
  };
}

export function ErrorResponseToJSON(json: any): ErrorResponse {
  return ErrorResponseToJSONTyped(json, false);
}

export function ErrorResponseToJSONTyped(
  value?: ErrorResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    errors: (value['errors'] as Array<any>).map(ErrorDetailToJSON),
  };
}
